import { Injectable } from '@angular/core';
import { Subject , Observable} from 'rxjs';

/**
 * Representa el servicio que activa o desactiva la capa de carga
 *
 * @class LoaderService
 * @service
 */
@Injectable()
export class LoaderService {
  /**
   * @property {Subject<boolean>} stateLoaderSource - Estado de la capa de carga
   */
  private stateLoaderSource: Subject<boolean> = new Subject<boolean>();
  /**
   * Crea la capa de carga
   */
  constructor() {}

  /**
   * @property {Observable<boolean>} loaderActive$
   */
  get loaderActive$(): Observable<boolean> {
    return this.stateLoaderSource.asObservable();
  }

  /**
   * Activa la capa de carga
   * @method activate
   */
  activate() {
    this.stateLoaderSource.next(true);
  }

  /**
   * Desactiva la capa de carga
   * @method desactivate
   */
  desactivate() {
    this.stateLoaderSource.next(false);
  }
}
